import React from 'react';

import { t } from '@lingui/macro';
import Combobox from './primitives/Combobox';
import Products from '../../../views/Products/ProductsComboboxView';
import { ProductListView } from '../../../../types/internal-api';
import { useProducts } from '../../hooks/masterdata/useProducts';

interface Props {
    showPrice?: boolean;
    showCreateOnTheFly?: boolean;
}

export default function ProductCombobox({ showPrice, showCreateOnTheFly, ...props }: Props) {
    const { data: products } = useProducts({ isAccessible: true, pageSize: 1000 });

    return (
        <Combobox
            {...props}
            aria-label={t`Products`}
            valueType="string"
            data={products.map(product => ({
                data: product,
                text: `${product.productNumber} - ${product.name}`,
                summary: product.name,
                value: product.productNumber,
            }))}
            modal={({ hide, onChange }) => (
                <Products
                    showPrice={showPrice}
                    showCreateOnTheFly={showCreateOnTheFly}
                    onCreated={(product: ProductListView) => {
                        onChange(product.productNumber, product, true);
                        hide();
                    }}
                    onSelected={(product: ProductListView) => {
                        onChange(product.productNumber, product);
                        hide();
                    }}
                />
            )}
            modalSize="sm"
            style={{ width: '140px' }}
        />
    );
}
